import React from 'react';
import BalanceSheetTable from '../balance-sheet/balance-sheet-table';
import IncomeStatementTableSheet from '../balance-sheet/income-statement-sheet-table ';
import ProfitAndLossSheet from '../balance-sheet/profit-loss-table';

const FinanceStatementViewTable = ({ data }) => {

  return (
    <>
    <BalanceSheetTable data={data?.financial_statement_shows[0]?.balance_sheet || []} tableType='' title={'Balance Sheet'} />
    <IncomeStatementTableSheet data={data?.financial_statement_shows[1]?.income_statement || []} title={'Income Statement'}/>
    <ProfitAndLossSheet data={data?.financial_statement_shows[2]?.profit_and_loss || []} title={'Profit/Loss Statement'}/>
    </>
  );
};

export default FinanceStatementViewTable;
